import { useMutation } from "@apollo/client";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { EToastColorStatus, EToastPosition } from "../../../../interfaces";
import { DEACTIVATE_COMPANY_USER } from "../../../../GraphQL/settings/mutations";

interface IDeactivateProps {
  showModalDeactivate: boolean;
  onCloseModal: () => void;
  userId: string | null;
  reloadCompanyUsers: () => void;
  onHandleCreateToast: (
    color    : EToastColorStatus,
    position : EToastPosition,
    message  : string,
  ) => void;
}

const DeactivateModal = ({
  showModalDeactivate,
  onCloseModal,
  userId,
  reloadCompanyUsers,
  onHandleCreateToast = () => {},
}: IDeactivateProps) => {
  const [deactivateUser] = useMutation(DEACTIVATE_COMPANY_USER, {
    onCompleted() {
      reloadCompanyUsers();
      onHandleCreateToast(
        EToastColorStatus.SUCCESS,
        EToastPosition.BOTTOM_END,
        "User successfully deactivated",
      );
    },
    onError() {
      onHandleCreateToast(
        EToastColorStatus.FAILED,
        EToastPosition.BOTTOM_END,
        "Error, something went wrong",
      );
    },
  });

  const handleDeactivate = () => {
    if (userId) {
      deactivateUser({ variables: { userId }});
    }
    onCloseModal();
  }

  return (
    <Dialog open={showModalDeactivate} onOpenChange={onCloseModal}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Deactivate User</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          Are you sure you want to deactivate this user? This process cannot be undone.
        </div>
        <DialogFooter>
          <Button variant="secondary" onClick={onCloseModal}>
            Close
          </Button>
          <Button variant="destructive" onClick={handleDeactivate}>
            Deactivate
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default DeactivateModal;
